<template>
  <div class="content-body">
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>
